module.exports = __webpack_public_path__ + "img/hx_10.475dc9a3.png";